import { Container } from '@mui/material';
import { useParams } from 'react-router-dom';

import { ContractDetailSellerPostNegotiationSign } from '@/components/ContractDetailSeller/ContractDetailSellerPostNegotiationSign';

export const BuyerPostNegotiationSignPage = () => {
  const { contractId } = useParams();

  if (!contractId) {
    return null;
  }

  return (
    <Container sx={{ py: '40px' }}>
      <ContractDetailSellerPostNegotiationSign uid={contractId} role="buyer" />
    </Container>
  );
};
